import { useFetchFn } from 'hooks/useFetchFn';
import { ApiJob } from 'modules/listing/api/job/types/ApiJob';
import { searchAlgoliaFetchSimilarJobsExperiment } from 'modules/search/algolia/fetch/similarJobs/searchAlgoliaFetchSimilarJobsExperiment';
import { SearchLoadingSectionMockResults } from 'modules/search/components/Loading/SearchLoadingSectionMockResults';
import { useMainSelector } from 'store/hooks/useMainSelector';

import { ViewJobPageSidebarSuggestionsHolder } from './ViewJobPageSidebarSuggestions.styled';
import { ViewJobPageSidebarSuggestionsHits } from './ViewJobPageSidebarSuggestionsHits';

type Props = {
  job: ApiJob;
};

export function ViewJobPageSidebarSuggestionsExperiment({ job }: Props) {
  const userSearchLocation = useMainSelector(
    (state) => state.mainSearch.searchLocation,
  );

  const [similarJobsResponse] = useFetchFn({
    fn: searchAlgoliaFetchSimilarJobsExperiment,
    args: [job.name, job.synonym, userSearchLocation],
  });

  return (
    <ViewJobPageSidebarSuggestionsHolder>
      {similarJobsResponse ? (
        <ViewJobPageSidebarSuggestionsHits
          jobId={job.id}
          queryID={similarJobsResponse.queryID}
          hits={similarJobsResponse.hits}
          page={similarJobsResponse.page}
          hitsPerPage={similarJobsResponse.nbPages}
        />
      ) : (
        <SearchLoadingSectionMockResults items={3} />
      )}
    </ViewJobPageSidebarSuggestionsHolder>
  );
}
